import React from "react";
import FormCheckbox from "./form-checkbox";
import FormRadio from "./form-radio";

const FormPrivacy = ({ data, labelManagerLabels }) => {
  const { privacy1FieldSet, privacy2FieldSet, privacy3FieldSet } = data;
  const yesLabel = labelManagerLabels.yes;
  const noLabel = labelManagerLabels.no;
  return (
    <>
      {privacy1FieldSet && privacy1FieldSet.privacy1 && (
        <FormCheckbox id="privacy1" field="privacy1" isRequired={true}>
          <div
            className="d-inline-block"
            dangerouslySetInnerHTML={{ __html: privacy1FieldSet.privacy1 }}
          />
        </FormCheckbox>
      )}
      {privacy2FieldSet && privacy2FieldSet.privacy2 && (
        <>
          <div
            className="form__label mt-4 mb-3"
            dangerouslySetInnerHTML={{ __html: privacy2FieldSet.privacy2 }}
          />
          <FormRadio
            id="privacy2"
            field="privacy2"
            isRequired={true}
            options={[
              { value: "true", label: yesLabel },
              { value: "false", label: noLabel },
            ]}
          />
        </>
      )}
      {privacy3FieldSet && privacy3FieldSet.privacy3 && (
        <>
          <div
            className="form__label mt-4 mb-3"
            dangerouslySetInnerHTML={{ __html: privacy3FieldSet.privacy3 }}
          />
          <FormRadio
            id="privacy3"
            field="privacy3"
            isRequired={true}
            options={[
              { value: "true", label: yesLabel },
              { value: "false", label: noLabel },
            ]}
          />
        </>
      )}
    </>
  );
};

export default FormPrivacy;
